// Copyright (c) Microsoft Corporation. All rights reserved.

import { PremeetingProps } from "../wego/hosts/WeGoHostedProps"
import React from "react"

interface SampleAppPremeetingProps extends PremeetingProps {}

type SampleAppPremeetingState = {}

/*
 ** Sample experience for apps that don't have a premeeting scenario. Apps can build richer pre-meeting experiences with authenticated user token.
 */
export default class SampleAppPremeeting extends React.Component<
  SampleAppPremeetingProps,
  SampleAppPremeetingState
> {
  /*
   ** Standard React render
   */
  render() {
    return (
      <div className="centered-container">
        {/* <iframe
          src="http://localhost:3000/rooms/5fc7aa672f137725d1bb3492"
          title="Spatial"
          allow="geolocation *; microphone *; camera *; midi *; encrypted-media *;"
          sandbox="allow-forms allow-modals allow-popups allow-pointer-lock allow-scripts allow-same-origin allow-downloads"
          allowFullScreen
          frameBorder="0"
        /> */}

        {/* YouTube embed to show that audio does work */}
        {/* <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/dQw4w9WgXcQ"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        /> */}

        <ProofThatWeCannotGetMicOrCamera />
        {/* <iframe
          src="http://localhost:3000/rooms/60d0d3835e4afb0001ca3af1"
          title="Spatial"
          allow="geolocation *; microphone *; camera *; midi *; encrypted-media *;"
          sandbox="allow-forms allow-modals allow-popups allow-pointer-lock allow-scripts allow-same-origin allow-downloads"
          allowFullScreen
          frameBorder="0"
        /> */}
        <iframe
          src="https://deploy-preview-6200--adoring-tesla-fc69b1.netlify.app/rooms/60d0d3835e4afb0001ca3af1"
          title="Spatial"
          allow="geolocation *; microphone *; camera *; midi *; encrypted-media *;"
          sandbox="allow-forms allow-modals allow-popups allow-pointer-lock allow-scripts allow-same-origin allow-downloads"
          allowFullScreen
          frameBorder="0"
        />
        {/* <iframe
          src="https://appr.tc/"
          title="Spatial"
          allow="geolocation *; microphone *; camera *; midi *; encrypted-media *;"
          sandbox="allow-forms allow-modals allow-popups allow-pointer-lock allow-scripts allow-same-origin allow-downloads"
          allowFullScreen
          frameBorder="0"
        /> */}
        {/* <br />
        <img
          src={`${process.env.PUBLIC_URL}/images/${this.props.appName}-logo.png`}
          className="App-small-logo"
          alt="logo"
        />
        <br />
        <br />
        <p>Welcome {this.props.userPrincipalName}!</p>
        <br />
        <br />
        <a
          href="https://docs.microsoft.com/en-us/microsoftteams/platform/overview"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn about Teams extensibility
        </a> */}
      </div>
    )
  }
}

// We cannot use audio/video at all
const ProofThatWeCannotGetMicOrCamera = () => {
  React.useEffect(() => {
    console.log("navigator.mediaDevices:", navigator.mediaDevices)
    navigator.mediaDevices
      .enumerateDevices()
      .then((resp) => console.log(resp))
      .catch((err) => console.log(err))

    navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then(function (stream) {
        console.log("stream:", stream)
        /* use the stream */
      })
      .catch(function (err) {
        // console.log("err:", err)
        console.error(err)
        console.log("err:", err.code, err.name, err.message)
        /* handle the error */
      })
  }, [])

  return null
}
